/* istanbul ignore file */
import { Typography } from '@mui/material';

const TimelineRecordFieldLayout = ({ value = null, label = null }) => {
  return (
    value && (
      <Typography variant="body1" component="div" mb={0}>
        {label ? (
          <Typography variant="subtitle1" component="span">
            {label}:
          </Typography>
        ) : null}
        {value}
      </Typography>
    )
  );
};

export default TimelineRecordFieldLayout;
